import { TailwindColor } from '@repo/tailwind-config/tailwind.vars'

type Props = {
  color1: TailwindColor
  color2: TailwindColor
  color3: TailwindColor
}

const LoginGroupThreeIcon: React.FC<Props> = ({ color1, color2, color3 }) => {
  return (
    <svg
      width="254"
      height="410"
      viewBox="0 0 254 410"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M127.066 254.264C110.38 254.264 93.8569 250.977 78.4409 244.592C63.0249 238.206 49.0176 228.846 37.2186 217.047C25.4197 205.248 16.0604 191.241 9.67484 175.824C3.28931 160.408 0.0027403 143.885 0.00274103 127.198L127.066 127.198L127.066 254.264Z"
        fill={color3}
      />
      <ellipse cx="63.5315" cy="63.6656" rx="63.5315" ry="63.5328" fill={color1} />
      <ellipse cx="64.0865" cy="63.1096" rx="30.9371" ry="30.9377" fill="white" />
      <rect x="127.064" y="0.132812" width="127.063" height="127.066" fill={color2} />
      <rect x="127.064" y="127.188" width="127.063" height="127.066" fill={color1} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M127.667 254.758C158.356 251.155 192.79 262.993 219.055 289.259C245.321 315.525 257.159 349.959 253.555 380.649C222.866 384.253 188.432 372.415 162.167 346.149C135.901 319.883 124.063 285.448 127.667 254.758Z"
        fill="white"
      />
    </svg>
  )
}

export default LoginGroupThreeIcon
